import React from 'react';
import {useEffect, useState, useRef} from 'react';

export default function FaithlifeTvVideo(props) {
  const fileDetails = props.file ? props.file.get('details').faithlife_tv_info : {id: ''};
  let iframe = useRef();

  let src = "https://faithlifetv.com/media/" + fileDetails.id + "?embedded=1&autoplay=0";
  return (
    <div style={{width: '100%', height: '100%', margin: 'auto'}}>
      <iframe
        ref={iframe}
        src={src}
        width="100%"
        height="100%"
        style={{border: 0}}
        frameBorder="0"
        title={props.file.get('title')}
        allowFullScreen>
      </iframe>
    </div>
  );
}
